import Ajv from 'ajv';
import { uid } from './keywords/uid';
const addFormats = require('ajv-formats');
export const ajv = new Ajv({ allowUnionTypes: true, $data: true, addUsedSchema: false, strictNumbers: false });
addFormats(ajv);
// additional keywords
require('ajv-keywords')(ajv); // add ajv-keywords (e.g. instanceof)
ajv.addKeyword(uid);
export function validate(schema, data) {
    const valid = ajv.validate(schema, data);
    if (!valid) {
        const errors = ajv.errorsText(ajv.errors, { separator: '.' });
        throw new Error(errors);
    }
}
export function compile(schema) {
    const validate = ajv.compile(schema);
    return (data) => {
        const valid = validate(data);
        if (!valid) {
            // I'm not sure the latter case can happen but types allow it, we'll generate a useful generic error just in case
            const errorMessage = validate.errors
                ? ajv.errorsText(validate.errors)
                : `Failed to validate ${JSON.stringify(data, null, 2)} against ${JSON.stringify(schema, null, 2)}`;
            throw new Error(errorMessage);
        }
    };
}
//# sourceMappingURL=validate.js.map